import type React from "react";

import { SectionCard } from "@/design-system/SectionCard";
import { useTranslation } from "@/translations";

import { AddProjectButton } from "./AddProjectButton";

type PortfolioOverviewEmptyStateProps = {
  onAddProject: () => void;
};

export function PortfolioOverviewEmptyState({ onAddProject }: PortfolioOverviewEmptyStateProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <SectionCard>
      <section className="flex h-illustration-compact flex-col items-center justify-center gap-space-md text-text-secondary">
        <span>{t("common.label.no-result")}</span>
        <AddProjectButton onClick={onAddProject}>{t("page.portfolio.add-new-project")}</AddProjectButton>
      </section>
    </SectionCard>
  );
}
